import PropTypes from 'prop-types';
import React, { Component } from 'react';
import utils from '../../utils/utilities.js';
import { OptionsType } from './../../types';
import FormGroup from './FormGroup.jsx';

export default class SelectField extends Component {

    static propTypes = {
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        options: OptionsType,
        classNames: PropTypes.string,
        label: PropTypes.any,
        hasError: PropTypes.any,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        inputAttributes: PropTypes.object,
        fieldId: PropTypes.string
    }

    static defaultProps = {
        label: null,
        hasError: false,
        disabled: false,
        required: false,
        classNames: "",
        fieldId: "selectField_" + utils.generateRandomHash()
    }

    render() {
        const options = this.props.options.map((option, index) =>
            <option value={option.value} key={this.props.fieldId + "_" + index}>{option.label}</option>)

        return (
            <FormGroup {...this.props} fieldId={this.props.fieldId}>
                <select
                    id={this.props.fieldId}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
                    {...this.props.inputAttributes}
                >
                    {options}
                </select>
            </FormGroup>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/Select.jsx